import * as React from "react";
const SvgWarningSign = () => /* @__PURE__ */ React.createElement("svg", { width: 42, height: 42, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M21 33.177c.937 0 1.696-.795 1.696-1.776s-.76-1.777-1.696-1.777-1.696.796-1.696 1.777.76 1.776 1.696 1.776"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.61 14.944a1.865 1.865 0 0 1 1.842 2.059l-.982 9.431a1.478 1.478 0 0 1-2.94 0l-.98-9.44a1.866 1.866 0 0 1 1.87-2.059z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M37.196 41a3.65 3.65 0 0 0 1.866-.502 3.87 3.87 0 0 0 1.388-1.4c.339-.584.528-1.251.548-1.935a4.1 4.1 0 0 0-.433-1.966l-16.2-32.075a3.9 3.9 0 0 0-1.401-1.55A3.7 3.7 0 0 0 21 1c-.692 0-1.37.198-1.964.571a3.9 3.9 0 0 0-1.4 1.55L1.435 35.198a4.11 4.11 0 0 0 .114 3.898 3.87 3.87 0 0 0 1.384 1.4c.57.334 1.212.508 1.864.505zm-33.26-4.547-.002.002a1.32 1.32 0 0 0 .036 1.237c.102.176.236.306.379.39a.85.85 0 0 0 .435.12h32.43a.85.85 0 0 0 .436-.12c.142-.083.278-.213.38-.39a1.316 1.316 0 0 0 .036-1.237l-.001-.002-16.198-32.07a1.1 1.1 0 0 0-.396-.445.9.9 0 0 0-.471-.14.9.9 0 0 0-.47.14 1.1 1.1 0 0 0-.397.445z",
    clipRule: "evenodd"
  }
));
export default SvgWarningSign;
